module.exports = __webpack_public_path__ + "img/iconJiaYouJiLu.dcd80b2a.svg";